module.exports = __webpack_public_path__ + "img/yk.8d1566ae.png";